var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYesOrNoRightSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 122,
    viewBox: "0 0 104 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4845 84.1834L58.1578 83.3268L57.3013 84.0001L57 81.4846L56.6987 84.0001L55.8422 83.3268L56.5155 84.1834L54 84.4846L56.5155 84.7859L55.8422 85.6424L56.6987 84.9691L57 87.4846L57.3013 84.9691L58.1578 85.6424L57.4845 84.7859L60 84.4846L57.4845 84.1834Z",
    fill: "#827677"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0653 91.6331L23.8508 90.6338L22.8515 91.4194L22.5 88.4846L22.1485 91.4194L21.1492 90.6338L21.9347 91.6331L19 91.9846L21.9347 92.3361L21.1492 93.3354L22.1485 92.5499L22.5 95.4846L22.8515 92.5499L23.8508 93.3354L23.0653 92.3361L26 91.9846L23.0653 91.6331Z",
    fill: "#827677"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.646 34.0829L55.5438 32.9409L54.4017 33.8386L54 30.4846L53.5983 33.8386L52.4562 32.9409L53.354 34.0829L50 34.4846L53.354 34.8863L52.4562 36.0284L53.5983 35.1306L54 38.4846L54.4017 35.1306L55.5438 36.0284L54.646 34.8863L58 34.4846L54.646 34.0829Z",
    fill: "#827677"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4845 63.1834L28.1578 62.3268L27.3013 63.0001L27 60.4846L26.6987 63.0001L25.8422 62.3268L26.5155 63.1834L24 63.4846L26.5155 63.7859L25.8422 64.6424L26.6987 63.9691L27 66.4846L27.3013 63.9691L28.1578 64.6424L27.4845 63.7859L30 63.4846L27.4845 63.1834Z",
    fill: "#827677"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.485 81.1834L102.158 80.3268L101.301 81.0001L101 78.4846L100.699 81.0001L99.8422 80.3268L100.515 81.1834L98 81.4846L100.515 81.7859L99.8422 82.6424L100.699 81.9691L101 84.4846L101.301 81.9691L102.158 82.6424L101.485 81.7859L104 81.4846L101.485 81.1834Z",
    fill: "#827677"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5833 33.8546C81.3488 33.0556 82.4581 33.1952 83.2314 33.9301C83.532 34.2261 83.8381 34.622 83.9879 35.0184C84.2571 35.8369 83.6412 36.2231 82.9195 36.3587C82.0545 36.5102 81.1345 36.316 80.272 36.4394C79.3659 36.5731 78.5143 36.896 77.7349 37.3673C76.9249 37.8643 77.5287 39.2374 78.3541 38.7275C79.223 38.2073 80.1309 37.8892 81.1551 37.8653C81.8799 37.8577 82.61 37.9499 83.3316 37.8144C84.5446 37.5798 85.6912 36.6438 85.5817 35.2997C85.3779 32.5988 81.6938 30.573 79.6191 32.7054C78.9633 33.3862 79.9122 34.5482 80.5833 33.8545L80.5833 33.8546Z",
    fill: "url(#paint0_linear_1698_19729)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.677 40.1118C76.2941 40.8472 77.4432 39.883 76.8261 39.1476C76.209 38.4122 75.0599 39.3763 75.677 40.1118Z",
    fill: "url(#paint1_linear_1698_19729)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 75.8546C15.3488 75.0556 16.4581 75.1952 17.2314 75.9301C17.532 76.2261 17.8381 76.622 17.9879 77.0184C18.2571 77.8369 17.6412 78.2231 16.9195 78.3587C16.0545 78.5102 15.1345 78.316 14.272 78.4394C13.3659 78.5731 12.5143 78.896 11.7349 79.3673C10.9249 79.8643 11.5287 81.2374 12.3541 80.7275C13.223 80.2073 14.1309 79.8892 15.1551 79.8653C15.8799 79.8577 16.61 79.9499 17.3316 79.8144C18.5446 79.5798 19.6912 78.6438 19.5817 77.2997C19.3779 74.5988 15.6938 72.573 13.6191 74.7054C12.9633 75.3862 13.9122 76.5482 14.5833 75.8545L14.5833 75.8546Z",
    fill: "url(#paint2_linear_1698_19729)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67704 82.1118C10.2941 82.8472 11.4432 81.883 10.8261 81.1476C10.209 80.4122 9.05994 81.3763 9.67704 82.1118Z",
    fill: "url(#paint3_linear_1698_19729)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8514 11.8348C61.384 10.8649 62.4916 10.7127 63.4288 11.2224C63.7957 11.4305 64.1938 11.7337 64.4412 12.0778C64.913 12.7987 64.4181 13.3312 63.7561 13.6489C62.9597 14.0192 62.0209 14.0697 61.2197 14.4121C60.3791 14.7758 59.6401 15.3081 59.0092 15.9651C58.3554 16.6548 59.294 17.8248 59.9593 17.1187C60.664 16.3913 61.4587 15.8491 62.4418 15.5608C63.1398 15.3659 63.8689 15.2661 64.5309 14.9484C65.6419 14.4078 66.5071 13.2069 66.0535 11.9371C65.1576 9.38092 61.0747 8.3776 59.6226 10.9744C59.1654 11.8017 60.3826 12.6785 60.8513 11.8348L60.8514 11.8348Z",
    fill: "url(#paint4_linear_1698_19729)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7314 19.1484C58.5178 19.6991 59.3782 18.4704 58.5918 17.9197C57.8053 17.3691 56.945 18.5978 57.7314 19.1484Z",
    fill: "url(#paint5_linear_1698_19729)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0965 57.82C49.7117 56.9002 50.8283 56.8451 51.7175 57.4345C52.0649 57.6739 52.4351 58.0106 52.6515 58.3749C53.0587 59.1343 52.5193 59.6215 51.8321 59.8804C51.0065 60.1798 50.0668 60.1484 49.2388 60.4196C48.3697 60.7086 47.5871 61.1745 46.9013 61.774C46.1899 62.4041 47.023 63.6515 47.7473 63.006C48.5127 62.3429 49.3516 61.872 50.3561 61.6705C51.0685 61.5372 51.8035 61.5012 52.4907 61.2424C53.6445 60.8008 54.6112 59.6799 54.2699 58.3753C53.6002 55.7508 49.6203 54.3954 47.9474 56.8558C47.4198 57.6401 48.556 58.6196 49.0965 57.82L49.0965 57.82Z",
    fill: "url(#paint6_linear_1698_19729)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3511 64.834C46.0865 65.4511 47.0507 64.302 46.3152 63.6849C45.5798 63.0678 44.6156 64.2169 45.3511 64.834Z",
    fill: "url(#paint7_linear_1698_19729)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1398 40.0053C24.4032 38.9306 25.4337 38.4969 26.4708 38.7466C26.8791 38.8527 27.3422 39.0425 27.6702 39.3109C28.3125 39.8852 27.9722 40.5275 27.415 41.0058C26.7416 41.5695 25.8479 41.8614 25.1626 42.3995C24.4447 42.9683 23.8687 43.6738 23.4293 44.4716C22.9763 45.307 24.1858 46.1943 24.6456 45.34C25.138 44.4551 25.7653 43.7256 26.6403 43.1927C27.2641 42.8238 27.9426 42.5386 28.4998 42.0604C29.433 41.2507 29.9579 39.8668 29.191 38.7577C27.6641 36.5205 23.4607 36.6081 22.7302 39.4922C22.5027 40.4097 23.9054 40.9415 24.1397 40.0052L24.1398 40.0053Z",
    fill: "url(#paint8_linear_1698_19729)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.019 47.877C23.9212 48.2053 24.4342 46.7958 23.5321 46.4675C22.6299 46.1391 22.1169 47.5486 23.019 47.877Z",
    fill: "url(#paint9_linear_1698_19729)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0583 68.9732C80.951 68.3193 82.0191 68.6495 82.653 69.5074C82.8977 69.8512 83.1303 70.2942 83.2091 70.7106C83.332 71.5634 82.6585 71.8368 81.9242 71.845C81.046 71.844 80.1737 71.4931 79.3029 71.4647C78.3874 71.439 77.4926 71.6092 76.6432 71.938C75.7592 72.2868 76.1154 73.7439 77.0168 73.3851C77.9628 73.0237 78.9122 72.8681 79.925 73.0223C80.64 73.1407 81.343 73.3583 82.0773 73.3501C83.3126 73.3297 84.6043 72.607 84.7298 71.2644C84.9981 68.5692 81.7218 65.9343 79.3083 67.6742C78.5443 68.2307 79.2769 69.5398 80.0583 68.9732L80.0583 68.9732Z",
    fill: "url(#paint10_linear_1698_19729)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1411 74.2835C74.6211 75.1149 75.9201 74.3649 75.4401 73.5335C74.9601 72.7021 73.661 73.4521 74.1411 74.2835Z",
    fill: "url(#paint11_linear_1698_19729)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5056 96.1726C79.4983 95.6837 80.4929 96.1943 80.9682 97.1493C81.1494 97.5303 81.3016 98.007 81.3069 98.4307C81.2798 99.2919 80.5691 99.4442 79.8445 99.3248C78.9798 99.1713 78.1817 98.6742 77.329 98.4951C76.4319 98.3108 75.5212 98.323 74.6276 98.4993C73.6964 98.6893 73.7942 100.186 74.7442 99.9893C75.7386 99.7976 76.7006 99.8093 77.6712 100.137C78.3548 100.378 79.0094 100.714 79.7339 100.834C80.954 101.028 82.3515 100.541 82.7083 99.2402C83.4406 96.6325 80.6715 93.4688 77.9926 94.7631C77.1435 95.1785 77.6378 96.5949 78.5056 96.1726L78.5056 96.1726Z",
    fill: "url(#paint12_linear_1698_19729)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7566 100.375C72.085 101.277 73.4945 100.764 73.1662 99.8616C72.8378 98.9595 71.4283 99.4725 71.7566 100.375Z",
    fill: "url(#paint13_linear_1698_19729)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7125 107.301C44.744 106.9 45.6903 107.495 46.0806 108.488C46.2279 108.884 46.338 109.372 46.3063 109.794C46.2043 110.65 45.483 110.74 44.7716 110.558C43.9236 110.329 43.1718 109.765 42.338 109.512C41.4603 109.25 40.552 109.183 39.6464 109.281C38.7023 109.389 38.6692 110.888 39.6327 110.775C40.6401 110.671 41.5974 110.766 42.5358 111.177C43.1958 111.477 43.8185 111.869 44.5299 112.051C45.7284 112.351 47.1631 111.987 47.6318 110.723C48.5886 108.189 46.1058 104.796 43.3243 105.852C42.4423 106.192 42.8112 107.646 43.7125 107.301L43.7125 107.301Z",
    fill: "url(#paint14_linear_1698_19729)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6222 110.898C36.8707 111.826 38.3196 111.438 38.0711 110.51C37.8226 109.583 36.3738 109.971 36.6222 110.898Z",
    fill: "url(#paint15_linear_1698_19729)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1698_19729",
    x1: 73.3667,
    y1: 39.1817,
    x2: 88.004,
    y2: 43.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1698_19729",
    x1: 74.8865,
    y1: 40.1031,
    x2: 77.8204,
    y2: 40.5551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1698_19729",
    x1: 7.36674,
    y1: 81.1817,
    x2: 22.004,
    y2: 85.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1698_19729",
    x1: 8.88649,
    y1: 82.1031,
    x2: 11.8204,
    y2: 82.5551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1698_19729",
    x1: 55.2595,
    y1: 18.8482,
    x2: 70.4449,
    y2: 18.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1698_19729",
    x1: 56.9655,
    y1: 19.3446,
    x2: 59.9165,
    y2: 19.0219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1698_19729",
    x1: 42.9146,
    y1: 64.3193,
    x2: 58.0319,
    y2: 65.7612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1698_19729",
    x1: 44.571,
    y1: 64.9627,
    x2: 47.5388,
    y2: 64.8984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1698_19729",
    x1: 20.5536,
    y1: 48.227,
    x2: 35.2523,
    y2: 44.4115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1698_19729",
    x1: 22.3301,
    y1: 48.2647,
    x2: 25.0969,
    y2: 47.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1698_19729",
    x1: 72.0263,
    y1: 72.9663,
    x2: 85.7388,
    y2: 79.4916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1698_19729",
    x1: 73.364,
    y1: 74.1377,
    x2: 76.1749,
    y2: 75.0923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1698_19729",
    x1: 69.9023,
    y1: 98.7103,
    x2: 82.2733,
    y2: 107.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1698_19729",
    x1: 71.0168,
    y1: 100.096,
    x2: 73.6191,
    y2: 101.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1698_19729",
    x1: 34.9208,
    y1: 109.079,
    x2: 46.4771,
    y2: 118.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1698_19729",
    x1: 35.9094,
    y1: 110.556,
    x2: 38.3774,
    y2: 112.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB6C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesOrNoRightSide);
export default __webpack_public_path__ + "static/media/yes-or-no-right-side.a71ef7964cfa92f0de9dc69353ac22b5.svg";
export { ForwardRef as ReactComponent };